module.exports = require('./assignIn');



/*****************
 ** WEBPACK FOOTER
 ** /home/runner/work/emarsys-integration-js/emarsys-integration-js/~/lodash/extend.js
 ** module id = 12
 ** module chunks = 1
 **/